import { render, staticRenderFns } from "./AppBarAuth.vue?vue&type=template&id=53bc402a&"
import script from "./AppBarAuth.vue?vue&type=script&lang=js&"
export * from "./AppBarAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bc402a')) {
      api.createRecord('53bc402a', component.options)
    } else {
      api.reload('53bc402a', component.options)
    }
    module.hot.accept("./AppBarAuth.vue?vue&type=template&id=53bc402a&", function () {
      api.rerender('53bc402a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppBarAuth.vue"
export default component.exports